import { color, fontFamily } from "style/constants";

export default {
  root: {
    "&$disabled": {
      backgroundColor: color.GRAY,
      color: color.BLACK
    },
    "&:hover": {
      backgroundColor: "",
      color: ""
    },
    "&:focus": {
      boxShadow: `0 0 8px 3px ${color.BLUE}`
    }
  },
  text: {
    backgroundColor: color.DARKBLUE,
    border: 0,
    borderRadius: 23,
    boxShadow: "none",
    color: color.WHITE,
    fontFamily: fontFamily.primary,
    fontWeight: 500,
    fontSize: "1rem",
    height: 47,
    lineHeight: "19px",
    padding: "14px 48px"
  }
};
